var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('PlaceHolderLoader',{attrs:{"height":"12px","width":"100%","custom-class":['mb-2 rounded']}}),_vm._v(" "),_c('PlaceHolderLoader',{attrs:{"height":"12px","width":"100%","custom-class":['mb-2 rounded']}}),_vm._v(" "),_c('PlaceHolderLoader',{attrs:{"height":"12px","width":"100%","custom-class":['mb-2 rounded']}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }